import type {
  AuditStatus,
  AuditTeamRole,
  AuditType,
  ChecklistResult,
  FindingStatus,
  FindingType,
} from './types';

export const AUDIT_STATUS_ORDER: AuditStatus[] = [
  'planificada',
  'en_curso',
  'informe_emitido',
  'cerrada',
];

export const AUDIT_STATUS_STEP_HINT: Record<AuditStatus, string> = {
  planificada: 'Alcance y equipo',
  en_curso: 'Checklist y hallazgos',
  informe_emitido: 'Informe y cierre',
  cerrada: 'Finalizada',
};

export const AUDIT_TYPE_LABEL: Record<AuditType, string> = {
  interna: 'Interna',
  externa: 'Externa',
};

export const AUDIT_STATUS_LABEL: Record<AuditStatus, string> = {
  planificada: 'Planificada',
  en_curso: 'En curso',
  informe_emitido: 'Informe emitido',
  cerrada: 'Cerrada',
};

export const FINDING_TYPE_LABEL: Record<FindingType, string> = {
  no_conformidad: 'No conformidad',
  observacion: 'Observación',
  oportunidad: 'Oportunidad',
  conformidad: 'Conformidad',
};

export const FINDING_STATUS_LABEL: Record<FindingStatus, string> = {
  abierto: 'Abierto',
  en_tratamiento: 'En tratamiento',
  cerrado: 'Cerrado',
};

export const TEAM_ROLE_LABEL: Record<AuditTeamRole, string> = {
  lider: 'Líder',
  auditor: 'Auditor',
  observador: 'Observador',
};

export const CHECKLIST_RESULT_LABEL: Record<ChecklistResult, string> = {
  conforme: 'Conforme',
  no_conforme: 'No conforme',
  no_aplica: 'No aplica',
};

export function checklistResultBadgeClass(result: ChecklistResult | null): string {
  switch (result) {
    case 'conforme':
      return 'bg-green-100 text-green-800';
    case 'no_conforme':
      return 'bg-red-100 text-red-800';
    case 'no_aplica':
      return 'bg-slate-100 text-slate-700';
    default:
      return 'bg-amber-50 text-amber-800';
  }
}

export function auditStatusBadgeClass(status: AuditStatus): string {
  switch (status) {
    case 'planificada':
      return 'bg-slate-100 text-slate-800';
    case 'en_curso':
      return 'bg-blue-100 text-blue-800';
    case 'informe_emitido':
      return 'bg-amber-100 text-amber-800';
    case 'cerrada':
      return 'bg-green-100 text-green-800';
    default:
      return 'bg-muted text-muted-foreground';
  }
}

export function findingTypeBadgeClass(type: FindingType): string {
  switch (type) {
    case 'no_conformidad':
      return 'bg-red-100 text-red-800';
    case 'observacion':
      return 'bg-amber-100 text-amber-800';
    case 'oportunidad':
      return 'bg-blue-100 text-blue-800';
    case 'conformidad':
      return 'bg-green-100 text-green-800';
    default:
      return 'bg-muted text-muted-foreground';
  }
}
